import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios'
import profileDefault from '@/assets/user_default.png'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        loadingBounce: null,
        errorModalShow: false,
        errorModalMsg: '',
        companyProfileImg: '',
        userName: null,
        userImage: null,
        selfPermissionList: null,
        permissionLoading: false,
        version: null
    },
    mutations: {
        setLoading (state, payload) {
            if (state.loadingBounce) {
                clearTimeout(state.loadingBounce)
            }

            if (payload) {
                state.loading = payload
            } else {
                state.loadingBounce = setTimeout(() => {
                    state.loading = payload
                }, 200)
            }
        },
        setErrorModalShow (state, payload) {
            state.errorModalShow = payload
        },
        setErrorModalMsg (state, payload) {
            state.errorModalMsg = payload
        },
        setUserProfile (state, payload) {
            state.userName = payload.name
            state.userImage = payload.image
        },
        setCompanyProfileImg (state, companyImage) {
            state.companyProfileImg = companyImage
        },
        setSelfPermissionList (state, permissions) {
            state.selfPermissionList = permissions
        },
        setPermissionLoading (state, status) {
            state.permissionLoading = status
        },
        setVersion (state, version) {
            state.version = version
        }
    },
    actions: {
        setLoading ({ commit }, payload) {
            commit('setLoading', payload)
        },
        setErrorModalShow ({ commit }, payload) {
            commit('setErrorModalShow', payload)
        },
        setErrorModalMsg ({ commit }, payload) {
            commit('setErrorModalMsg', payload)
        },
        changeCompanyProfileImg ({ commit }, payload) {
            commit('setCompanyProfileImg', payload)
        },
        async getUserProfile ({ commit }, lang) {
            const res = await axios.get('user/profile')
            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                const payload = {
                    name: null,
                    image: null
                }

                payload.name = `${response[`first_name_${lang}`]} ${response[`last_name_${lang}`]}`
                // set default image for empty f_path
                if (!response.f_path) {
                    payload.image = profileDefault
                } else {
                    payload.image = response.f_path
                }

                commit('setUserProfile', payload)
            }
        },
        async getCompanyProfileImg ({ commit }) {
            const res = await axios.get('company/img')

            if (res && res.data && res.data.status === 'ok') {
                const companyImage = res.data.data

                commit('setCompanyProfileImg', companyImage)
            }
        },
        async getSelfPermissionList ({ state, commit }) {
            if (!state.permissionLoading) {
                commit('setPermissionLoading', true)
                const res = await axios.get('user/self-permission')

                if (res && res.data && res.data.status === 'ok') {
                    const selfPermissionList = res.data.data
                    commit('setSelfPermissionList', selfPermissionList)
                }
                commit('setPermissionLoading', false)
                return state.selfPermissionList
            } else {
                return new Promise((resolve) => {
                    setTimeout(() => { resolve(state.selfPermissionList) }, 100)
                })
            }
        },
        async getVersion ({ state, commit }) {
            let version = state.version
            if (!state.version) {
                try {
                    const res = await axios.get('version')

                    if (res && res.data && res.data.status === 'ok') {
                        version = res.data.version
                        commit('setVersion', version)
                    }
                } catch (_) {
                    version = 'Version 1.0.5'
                }
            }
            return version
        }
    },
    modules: {
    }
})
